import { errorHandler } from "@/services/utils";
import api from "@/services/modules/referee";

export const CREATE_REFEREE = "CREATE_REFEREE";
export const UPDATE_REFEREE = "UPDATE_REFEREE";

const actions = {
  async [CREATE_REFEREE]({ commit, dispatch }, data) {
    try {
      const { data: referee } = await api({ commit }).addNewReferee(data);
      return referee;
    } catch (exception) {
      errorHandler(dispatch, exception);
    }
  },
  async [UPDATE_REFEREE]({ commit, dispatch }, data) {
    try {
      await api({ commit }).updateReferee(data);
    } catch (exception) {
      errorHandler(dispatch, exception);
    }
  }
};

export default actions;
